"use client";

import { useMemo } from "react";
import { useT } from "@tillix/i18n/react";
import { type AppointmentT, appointmentNamespace } from "./index";

export function useAppointmentT(): AppointmentT {
  const { t } = useT(appointmentNamespace.ns);
  return useMemo(() => appointmentNamespace.wrap(t), [t]);
}

export type { AppointmentKey } from "./index";
